import React from 'react';
import {classNames} from "../../utils/common";

const Filter = ({filter, setFilter, withLabel = true, wideField = true, smallerSize = false, ...props}) => {
    return (
        <div {...props}>
            {withLabel && <label htmlFor="filter" className={classNames(
                smallerSize ? "ml-1 text-xs" : "ml-3 text-sm",
                "block font-medium text-gray-700"
            )}>Filter</label>}
            <div className={classNames(
                smallerSize ? "mt-0.5 h-7" : "mt-1 h-10",
                "relative rounded-md shadow-sm"
            )}>
                <input
                    value={filter}
                    onChange={(event) => setFilter(event.target.value)}
                    type="text"
                    id="filter"
                    className={classNames(
                        "focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 rounded-md",
                        smallerSize ? "h-7 px-2 text-xs" : "h-10 px-3 sm:text-sm",
                        wideField ? "w-96" : smallerSize ? "w-48" : ""
                    )}
                />
                {filter !== '' && (
                    <div
                        className={classNames(
                            smallerSize ? "pr-2 text-xs" : "pr-3 text-sm",
                            "absolute inset-y-0 right-0 flex items-center text-red-900 cursor-pointer"
                        )}
                        onClick={() => setFilter('')}
                    >
                        Reset
                    </div>
                )}
            </div>
        </div>
    );
};

export default Filter;
